'use client';

// import { useDarkMode } from "../../utils/hooks/useDarkMode";

// export default function TrustpilotWidget({ 
//   textColor = null, 
//   backgroundColor = 'transparent', 
//   fontSize = 'text-xs',
//   className = 'items-center justify-center',
//   rating = '4.7',
//   showIntroText = false,
//   introText = "Our Customers say:"
// }) {
//   const { isDarkMode } = useDarkMode();

//   // Determine text color based on props or dark mode
//   const getTextColor = () => {
//     if (textColor) return textColor;
//     return isDarkMode ? 'text-white' : 'text-gray-900';
//   };

//   return (
//     <div 
//       className={`flex items-center justify-center flex-wrap gap-1 ${className}`}
//       style={{ backgroundColor }}
//     >
//       {showIntroText && (
//         <span className={`${fontSize} font-medium ${getTextColor()}`}>
//           {introText}
//         </span>
//       )}
//       <span className={`${fontSize} font-medium ${getTextColor()}`}>
//         Excellent {rating} OUT OF 5 BASED ON
//       </span>
//       <div className="flex items-center gap-1">
//         <svg 
//           className="w-4 h-4 text-green-500 flex-shrink-0" 
//           fill="currentColor" 
//           viewBox="0 0 20 20"
//         >
//           <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//         </svg>
//         <span className={`${fontSize} font-medium ${getTextColor()}`}>
//           Trustpilot
//         </span>
//       </div>
//     </div>
//   );
// }

// Original Trustpilot Widget Code (Commented Out)
import { useEffect } from "react";
import { useDarkMode } from "../../utils/hooks/useDarkMode";

export default function TrustpilotWidget({ isForceDarkMode = false }) {
  const { isDarkMode } = useDarkMode();

  useEffect(() => {
    const scriptId = "trustpilot-script";

    // Add script if not already loaded
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      script.onload = () => {
        if (window.Trustpilot) {
          window.Trustpilot.loadFromElement(
            document.querySelector(".trustpilot-widget"),
            true
          );
        }
      };
      document.body.appendChild(script);
    } else {
      // Script already exists → force reload widget
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(
          document.querySelector(".trustpilot-widget"),
          true
        );
      }
    }
  }, [isDarkMode]); // re-run whenever theme changes

  return (
    <div
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="652d0d149b896e538a303969"
      data-style-height="24px"
      data-style-width="100%"
      data-theme={isForceDarkMode ? "light" : isDarkMode ? "dark" : "light"}
    >
      <a
        href="https://uk.trustpilot.com/review/hirego.co.uk"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
}
// 'use client';

// import { useEffect } from 'react';
// import { useDarkMode } from '../utils/useDarkMode';

// export default function TrustpilotWidget() {
//     const { isDarkMode } = useDarkMode();

//     useEffect(() => {
//         // Load TrustBox script after component mounts
//         const script = document.createElement('script');
//         script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
//         script.async = true;
//         console.log("script", script);
//         document.body.appendChild(script);
//     }, []);

//     return (
//         <div
//             key={isDarkMode ? 'dark' : 'light'}
//             className="trustpilot-widget"
//             data-locale="en-GB"
//             data-template-id="5419b637fa0340045cd0c936"
//             data-businessunit-id="652d0d149b896e538a303969"
//             data-style-height="20px"
//             data-style-width="100%"
//             data-theme={isDarkMode ? 'dark' : 'light'}>
//             <a href="https://uk.trustpilot.com/review/hirego.co.uk" target="_blank" rel="noopener noreferrer">
//                 Trustpilot
//             </a>
//         </div>
//     );
// }

